import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "./reducers";
import { logger } from "../config";

const loggerMiddleware = createLogger();
let middleware;
if (!logger) {
	middleware = applyMiddleware(thunkMiddleware, loggerMiddleware);
} else 
  middleware = applyMiddleware(thunkMiddleware);

export const configureStore = createStore(rootReducer, middleware);



// WEBPACK FOOTER //
// ./src/store/configureStore.js